module.exports = __webpack_public_path__ + "img/member-more-vertical.4ddc6dab.svg";